export default __webpack_public_path__ + "static/img_2-ee5aead63f886e53919ff16af785d96a.png";